<div class="row">
  @for (child of children; track child) {
    <ng-template #children></ng-template>
  }
</div>